module.exports = __webpack_public_path__ + "img/in-icon.276c622b.svg";